import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { roundTo2Decimals } from 'utils/calcUtils';
import {
  HIDE_NEW_PRODUCT_VARIANT_MODAL,
  RESET_NEW_OPTION,
  RESET_VARIANT_VALUES_OF_NEW_VARIANT,
  SET_PRICE_OF_NEW_VARIANT,
  SET_STOCK_COUNT_OF_NEW_VARIANT,
  SET_BARCODE_OF_NEW_VARIANT,
  SET_SHOPIFY_SKU_OF_NEW_VARIANT,
  SET_VARIANT_VALUES_OF_NEW_VARIANT,
  SHOW_NEW_PRODUCT_VARIANT_MODAL,
  START_LOADING,
  STOP_LOADING,
} from '../../singleProductSlice';
import API from 'utils/atolyeAPI';
import alert from 'js/sweetAlert';

import ProductImage from '../ProductImage';

const AtolyeAPI = new API();

const NewProductVariantModal = ({ getProduct, userId }) => {
  //Redux
  const { productCode } = useSelector((state) => state.products.singleProduct);
  const { isNewProductVariantModalDisplayed, variantOptions } = useSelector(
    (state) => state.products.singleProduct.variants,
  );

  const { variantValues, image_link, price, stock_count, barcode, shopifySKU } = useSelector(
    (state) => state.products.singleProduct.variants.newProductVariant,
  );

  const dispatch = useDispatch();

  // Functions
  const handleDismiss = () => {
    dispatch(RESET_NEW_OPTION());
    dispatch(HIDE_NEW_PRODUCT_VARIANT_MODAL());
  };

  const handleShow = () => {
    if (variantOptions.length < 1) {
      return alert(
        'error',
        'Ürün Varyantı oluşturmadan önce Varyant Seçeneği oluşturmanız gerekmektedir!',
      );
    }
    dispatch(RESET_VARIANT_VALUES_OF_NEW_VARIANT());
    dispatch(SHOW_NEW_PRODUCT_VARIANT_MODAL());
  };

  const handleSave = async () => {
    dispatch(START_LOADING());
    const body = {
      name: variantValues.map((item) => item.name).join(' / '),
      products_id: productCode,
      image_link,
      price,
      stock_count,
      barcode,
      shopifySKU,
      variantValues,
      createdBy: userId,
      updatedBy: userId,
    };
    try {
      const { status } = await AtolyeAPI.post(`/product_variants`, body);
      if (status === 'SUCCESS') {
        await getProduct();
        return alert('success', 'Ürün Varyantı başarıyla oluşturuldu');
      }
      throw new Error('Ürün Varyantı oluşturulurken bir hata oluştu');
    } catch (error) {
      console.log({ error });
      return alert('error', 'Ürün Varyantı oluşturulurken bir hata oluştu');
    } finally {
      dispatch(STOP_LOADING());
      dispatch(RESET_VARIANT_VALUES_OF_NEW_VARIANT());
      dispatch(HIDE_NEW_PRODUCT_VARIANT_MODAL());
    }
  };

  return (
    <div className="text-center">
      <div className="text-center">
        <Button variant="outline-success" className="btn-sm my-2" onClick={handleShow}>
          + Yeni Variant Ekle
        </Button>
      </div>
      <Modal
        show={isNewProductVariantModalDisplayed}
        onHide={handleDismiss}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header className="bg-light" closeButton>
          <Modal.Title className="text-success">Yeni Ürün Varyantı Ekle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-light p-2 text-center">
            <strong className="me-3">{productCode}</strong>{' '}
            <span className="text-muted">{variantValues.map((item) => item.name).join(' / ')}</span>
          </div>
          <Row>
            <Col md>
              <Form className="p-3">
                {variantOptions.map((option) => (
                  <Row key={'new-variant-o-' + option.id} className="my-2">
                    <Form.Label className="bg-light text-dark rounded border shadow-sm">
                      {option.name}
                    </Form.Label>
                    {option.values.map((value) => (
                      <Form.Check
                        key={value.id}
                        type="radio"
                        label={value.name}
                        checked={variantValues.includes(value)}
                        onChange={() => dispatch(SET_VARIANT_VALUES_OF_NEW_VARIANT(value))}
                      />
                    ))}
                  </Row>
                ))}
              </Form>
            </Col>
            <Col md>
              <ProductImage isVariant imageSrc={image_link} />
            </Col>
          </Row>
          <Row>
            <Col md>
              <Form className="p-3">
                <Row>
                  <Form.Label className="bg-light text-danger rounded border shadow-sm">
                    Fiyat (KDVsiz)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={roundTo2Decimals(price)}
                    onChange={(e) => dispatch(SET_PRICE_OF_NEW_VARIANT(e.target.value))}
                  />
                </Row>
              </Form>
            </Col>
            <Col md>
              {' '}
              <Form className="p-3">
                <Row>
                  <Form.Label className="bg-light text-success rounded border shadow-sm">
                    Fiyat (KDVli)
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={roundTo2Decimals(price * 1.18)}
                    onChange={(e) =>
                      dispatch(SET_PRICE_OF_NEW_VARIANT(e.target.value / 1.18 || ''))
                    }
                  />
                </Row>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col md>
              <Form className="p-3">
                <Row>
                  <Form.Label className="bg-light text-primary rounded border shadow-sm">
                    Stok Adedi
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={stock_count}
                    onChange={(e) => dispatch(SET_STOCK_COUNT_OF_NEW_VARIANT(e.target.value))}
                  />
                </Row>
              </Form>
            </Col>
            <Col md></Col>
          </Row>
          <Row>
            <Col md>
              <Form className="p-3">
                <Row>
                  <Form.Label className="bg-light text-secondary rounded border shadow-sm">
                    Barkod
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={barcode}
                    onChange={(e) => dispatch(SET_BARCODE_OF_NEW_VARIANT(e.target.value))}
                  />
                </Row>
              </Form>
            </Col>
            <Col md>
              <Form className="p-3">
                <Row>
                  <Form.Label className="bg-light text-info rounded border shadow-sm">
                    Shopify SKU
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={shopifySKU}
                    onChange={(e) => dispatch(SET_SHOPIFY_SKU_OF_NEW_VARIANT(e.target.value))}
                  />
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleDismiss}>
            Vazgeç
          </Button>
          <Button variant="success" className="text-white" onClick={handleSave}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NewProductVariantModal;
